import { jsx } from "react/jsx-runtime";
import { ButtonBase, styled } from "@mui/material";
import { memo } from "react";
function createIconButtonTrigger(props) {
  const { icon, squared } = props;
  function IconButtonTrigger(triggerProps) {
    return /* @__PURE__ */ jsx(
      BaseButton,
      {
        squared,
        sx: triggerProps.sx,
        onClick: triggerProps.onClick,
        disabled: triggerProps.disabled,
        children: icon
      }
    );
  }
  const memoIconButtonTrigger = memo(IconButtonTrigger);
  return memoIconButtonTrigger;
}
const BaseButton = styled(ButtonBase, {
  slot: "IconButtonTrigger"
})(({ squared, theme }) => {
  return {
    width: 48,
    height: 48,
    backgroundColor: theme.palette.action.focus,
    borderRadius: squared ? 0 : "50%"
  };
});
export {
  BaseButton,
  createIconButtonTrigger
};
//# sourceMappingURL=IconButtonTrigger.js.map
